import modalStyles from "../modals.module.scss"
import styles from "./styles.module.scss"
import { Modal } from "@/shared/types"
import {
  useContentCacheStore,
  useModalStore,
  useAutoTranslation,
} from "@/entities"
import { useEffect } from "react"
import { DISCOVERED_TRANSLATION_KEYS } from "@/shared/constants"
import { ArchivedList } from "@/widgets/library/archived-list"

/** Header shortcut to the archived items; the same list also lives in the
 * library's "Archived" tab (widgets/library/archived-list). */
export const ArchivedContentModal = () => {
  const { t } = useAutoTranslation()
  const setActiveArchivedPage = useContentCacheStore(
    s => s.setActiveArchivedPage
  )
  const handleClose = () => {
    useModalStore.getState().closeModal(Modal.ARCHIVED_CONTENT)
    setActiveArchivedPage(1)
  }

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handleClose()
      }
    }

    window.addEventListener("keydown", handleKeyPress)
    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [])

  return (
    <div className={modalStyles.backdrop} onClick={handleClose}>
      <div className={styles.wrapper}>
        <div className={styles.card} onClick={e => e.stopPropagation()}>
          <h1 className={styles.header__title}>
            {t(DISCOVERED_TRANSLATION_KEYS.ARCHIVED_FILES)}
          </h1>

          <div className={styles.content}>
            <ArchivedList />
          </div>
        </div>
      </div>
    </div>
  )
}
